<template>
  <v-container
    id="regular-tables"
    fluid
    tag="section"
  >
    <br>
    <h2 class="title-style">
      <v-icon class="icon-style">
        mdi-credit-card-clock-outline
      </v-icon> Advertisers List
    </h2>
    <v-card
      shaped
      color="#CFD8DC"
    >
      <br>
      <v-card-title>
        <v-row>
          <v-col
            cols="12"
            lg="4"
          >
            <v-text-field
              v-model="search"
              label="Search"
              append-icon="mdi-magnify"
              outlined
              dense
            />
          </v-col>
        </v-row>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="digiBoardAdvertisers"
        :search="search"
        class="elevation-1"
        mobile-breakpoint="100"
      >
        <template #item="{ item }">
          <tr>
            <td>{{ item.advertiser.name }}</td>
            <td>{{ item.advertiser.category }}</td>
            <td>
              <v-chip
                color="#37474F"
                small
                outlined
                dark
              >
                {{ item.time_slots.length }}
              </v-chip>
            </td>
            <td>
              <v-btn
                class="mt-n2"
                elevation="1"
                fab
                x-small
                icon
                color="#37474F"
                @click.stop
                @click="getTimeSlotsDetails(item.time_slots)"
              >
                <v-icon>mdi-eye</v-icon>
              </v-btn>
            </td>
          </tr>
        </template>
      </v-data-table>
      <centre-spinner
        :loading="loading"
      />
      <digi-board-advertiser-time-slots
        v-if="showAdvTimeSlots"
        :adv-time-slots-list="advertiserPurchasedTimeSlots"
        @closed="showAdvTimeSlots = false"
      />
    </v-card>
  </v-container>
</template>

<script>
  import spinner from 'src/views/dashboard/component/SpinnerCentre';
  import digiBoardAdvertiserTimeSlots from 'src/views/dashboard/digiboards/DigiBoardAdvertiserTimeSlots.vue';
  export default {
    name: 'OrganizationList',
    components: {
      'centre-spinner': spinner,
      'digi-board-advertiser-time-slots': digiBoardAdvertiserTimeSlots,
    },
    data () {
      return {
        search: '',
        loading: false,
        headers: [
          { text: 'Organization Name', align: 'start', value: 'organization_name' },
          { text: 'Category', value: 'category' },
          { text: 'Purchased Slots', value: 'purchased_slots' },
          { text: 'View Slots', value: 'view_slots' },
        ],
        advertiserPurchasedTimeSlots: [],
        showAdvTimeSlots: false,
      };
    },
    computed: {
      digiBoardAdvertisers () {
        return this.$store.getters['digiboards/getDigiBoardAdvertisersList'];
      },
    },
    async mounted () {
      await this.getDigiBoardAdvertisersList();
    },
    methods: {
      async getDigiBoardAdvertisersList () {
        const digiBoardId = this.$route.params.id;
        this.loading = true;
        await this.$store.dispatch('digiboards/fetchDigiBoardAdvertisersList', {
          digiBoard: digiBoardId,
        });
        this.loading = false;
      },
      getTimeSlotsDetails (timeSlots) {
        this.advertiserPurchasedTimeSlots = timeSlots;
        this.showAdvTimeSlots = true;
      },
    },
  };
</script>
<style scoped>
.icon-style {
  color: #37474F;
  font-size: 45px;
}
.title-style {
  color: #37474F;
  margin-left: 20px;
}
.v-data-table::v-deep th {
  font-size: 12px !important;
  color: #37474F !important;
  font-weight: bold !important;
}
.v-data-table::v-deep td {
  font-size: 13px !important;
  color: #37474F !important;
}
.theme--light.v-data-table tbody tr:nth-of-type(even) {
  background-color: #CFD8DC
}
.v-data-table { background-color: #ECEFF1; }
.my-status-style {
  font-weight: bold;
  font-size: 15px;
}
</style>
